export { ProtectedLayout as default } from '@/src/features/auth/ui/layouts/ProtectedLayout'
